var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsumatorInaltaTensiune(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 80,
    viewBox: "0 0 76 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 64.6602L38.5 79.5",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9189 26.1621C48.3676 26.1621 56.8378 34.6324 56.8379 45.0811C56.8379 55.5298 48.3677 64 37.9189 64C27.4703 63.9999 19 55.5297 19 45.0811C19.0001 34.6324 27.4703 26.1622 37.9189 26.1621Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4561 4C47.0966 4.00009 54.9121 11.8155 54.9121 21.4561C54.912 31.0965 47.0965 38.912 37.4561 38.9121C27.8155 38.9121 20.0001 31.0966 20 21.4561C20 11.8154 27.8154 4 37.4561 4Z",
    stroke: "black",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumatorInaltaTensiune);
export default __webpack_public_path__ + "static/media/consumator_inalta_tensiune.835edf41976c346dc6be24611cf05281.svg";
export { ForwardRef as ReactComponent };